// extracted by mini-css-extract-plugin
module.exports = {"tag__text":"SubHeader_tag__text__VcFFv","wrapper":"SubHeader_wrapper__dAKtV","bg":"SubHeader_bg__1Xy8j","accordion__wrapper":"SubHeader_accordion__wrapper__QLeav"};